import { Component, Inject, Input, OnInit } from '@angular/core';
import { SubdimensionModel } from 'src/app/model/FaseAnual.model';
import { FaseAnualSeguimientoComponent } from '../fase-anual-seguimiento.component';

@Component({
  selector: 'app-subdimension-anual-seguimiento',
  templateUrl: './subdimension-anual-seguimiento.component.html',
  styleUrls: ['./subdimension-anual-seguimiento.component.css']
})
export class SubdimensionAnualSeguimientoComponent{

  @Input() indice : number;
  @Input() estadoData : number;
  @Input() areaNumber : number;
  @Input() subdimensionData : SubdimensionModel;

  constructor(
    @Inject(FaseAnualSeguimientoComponent) private parentFE: FaseAnualSeguimientoComponent,
  ) { }

  change(){
    this.parentFE.cambios = true;
  }
}
